import { lazyNamed } from 'src/utils/lazyNamed';

export const AdPrice = {
  List: lazyNamed(() => import('./containers/AdPriceListPage'), 'AdPrices'),
  Edit: lazyNamed(() => import('./containers/AdPriceFormPage'), 'AdPriceFormPage'),
  History: lazyNamed(() => import('./containers/AdPriceHistory'), 'AdPriceHistory'),
};
